import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ModelFilter extends Component {
    state = {
        modelLists:[],
        modelValue:'',
    };
    componentDidMount(){
        this._getModel('',this.props.start_date,this.props.end_date);
    }

    _getModel(brandArray,start_date, end_date){
        this.setState({
             modelLists:[],
             modelValue:[],

        })
        axios.post(config.get('API_URL')+'/reports/emi-debit-card-model/',{
                yestSend:start_date,
                todSend:end_date,
                brandArray: brandArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    modelLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((model, index) => {
                    this.state.modelLists.push({value: model.model, label: model.model})
                });
            }
        });
    }
    changeModel(optionSelected){
        let value='';
        let modelArray = [];
        if(optionSelected.length < 1){
            value = null;
            modelArray= '';
        }
        else{
            optionSelected.map((mids, i) => {
                modelArray.push(mids.value)
                var index = this.state.modelLists.findIndex(obj => obj.value==mids.value);
                this.state.modelLists.move(index,0).join(',');
            });
        }
        this.props.onSelectmodel(optionSelected, modelArray);
        this.setState({
            modelIDs:modelArray,
            modelValue:optionSelected,

        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="model"
            isMulti
            value={this.state.modelValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeModel.bind(this)}
            options={this.state.modelLists}
            placeholderButtonLabel="Select[Model]"
         />
        );

    }
}
export default ModelFilter;